<template>
  <div class="home">
    <div class="video-header" ref="video">
      <video class="inner setResolution autoplay" preload="none" loop playsinline muted autoplay is-playing="false" data-object-fit="cover" hasaudio="false" style="width: 100%; height: 100%; -o-object-fit: cover; object-fit: cover; background-color: #000; left: 0; top: 0;">
        <source :src="pageApiData.video.xl">
        <source :src="pageApiData.video.l" media="all and (max-width:1280px)">
        <source :src="pageApiData.video.m" media="all and (max-width:960px)">
        <source :src="pageApiData.video.s" media="all and (max-width:640px)">
      </video>
      <div class="default-container common-hero__container">
        <h1 v-html="pageApiData.title"></h1>
      </div>
      <div
        class="home-scroll-invite"
        @click="$_scrollBottom">
        <span>{{ $t('scorri') }}</span>
        <div class="v-line"></div>
      </div>
    </div>
    <section class="paragrafo-home paragrafo-home--sfondo">
      <div
        v-html="pageApiData.description"
        class="default-container"></div>
    </section>
    <section class="paragrafo-semplice">
      <div
        v-html="pageApiData.content"
        v-animate-on-intersection
        class="default-container"></div>
    </section>

    <listing-lavorazioni-gallery
      :list="pageApiData.lavorazioni"
      :lang="lang"/>

  </div>
</template>

<script>
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import HeroCta from '@/components/HeroCta'
import ListingLavorazioniGallery from '@/components/ListingLavorazioniGallery'

export default {
  mixins: [ lang, dataLoad ],
  name: 'home',
  components: {
    HeroCta,
    ListingLavorazioniGallery
  },
  methods: {
    $_scrollBottom () {
      window.scroll({ top: this.$refs.video.offsetHeight, left: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss">
@import "../assets/mixins/breakpoints";
@import "../assets/mixins/typo";

.home{
  background-color: #FFF;

  .listing-internal-pages{
    padding-top: 4rem;
    padding-bottom: 4rem;
    @media #{$medium_mq} {
      padding-top: 4rem;
      padding-bottom: 6rem;
    }
    @media #{$large_mq} {
      padding-bottom: 8rem;
    }
    @media #{$xlarge_mq} {
      padding-bottom: 10rem;
    }
  }
}

.paragrafo-home{
  background: #1D1D1B;

  &.paragrafo-home--sfondo{
    background: #1D1D1B url('/home/sfondo-paragrafo.jpg') center center;
    background-size: cover;
  }
  padding: 90px 0;

  @media #{$medium_mq} {
    padding: 140px 0;
  }
  @media #{$large_mq} {
    padding: 180px 0;
  }
  @media #{$xlarge_mq} {
    padding: 210px 0;
  }
  @media #{$xxlarge_mq} {
    padding: 240px 0;
  }
  h2 {
    @include section-title(#EFEFF1);
    br{
      display: none;
      @media #{$large_mq} {
        display: block;
      }
    }
  }

  p {
    @include section-paragraph(#EFEFF1);
    br{
      display: none;
      @media #{$large_mq} {
        display: block;
      }
    }
  }
}

.paragrafo-semplice {
  background-color: #FFF;
  padding: 80px 0 80px;

  @media #{$medium_mq} {
    padding: 90px 0 0;
  }
  @media #{$large_mq} {
    padding: 110px 0 0;
  }
  @media #{$xlarge_mq} {
    padding: 130px 0 0;
  }
  @media #{$xxlarge_mq} {
    padding: 150px 0 0;
  }

  h3 {
    @include title-72-pixel(#4a4a4a);
    line-height: 1;
    margin-bottom: 1rem;
    margin-top: 0;
    text-transform: uppercase;
    font-weight: 400;
  }

  p {
    @include size-18-pixel(#4a4a4a);
    line-height: 1.8;
    margin-bottom: 0;
  }

}

.home .listing-lavorazioni .listing-lavorazioni__content.hide-for-medium p{
  display: none;
}

.home .listing-lavorazioni.listing-lavorazioni--gallery{
  cursor: grab;
}

.video-header{
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.video-header video{
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  background-color: #000;
  position: absolute;
}

</style>
